<template>
    <!-- ERROR STATE -->
    <div v-if="errorMessage" class="my-8 md:my-16 space-y-8">
        <div class="max-w-2xl mx-auto">
            <div class="text-center">
                <i class="icon-close mx-auto size-16 rounded-full flex items-center justify-center bg-red-50 text-3xl text-red-700" />
            </div>
            <div class="space-y-3 my-6 text-center">
                <h1 class="text-2xl font-semibold text-red-700">
                    {{ $t('Your reservation could not be completed.') }}
                </h1>
                <h2>
                    {{ errorMessage }}
                </h2>
            </div>
        </div>
    </div>
    <!-- REDIRECTING STATE -->
    <div v-else class="min-h-[50vh] flex items-center justify-center relative">
        <Loading message="We are redirecting you to the payment." class="min-h-[50vh]" />
        <!-- Auto-submit POST form -->
        <form v-if="form" ref="formEl" :action="form.action" :method="form.method" class="hidden">
            <input v-for="(value, key) in form.fields" :key="key" type="hidden" :name="key" :value="value" />
        </form>
    </div>
</template>

<script setup>
import { useAsyncRequest } from '@/composables/useAsyncRequest'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { get } = useAsyncRequest()

const props = defineProps({
    orderId: {
        type: String,
        required: true
    }
})

const form = ref(null)
const formEl = ref(null)
const errorMessage = ref(null)

/**
 * ⬇️ Suspense waits here
 */
try {
    const data = await get(`/api/orders/${props.orderId}/payment`)

    if (!data?.action || !data?.fields) {
        throw new Error('Invalid payment response')
    }

    form.value = {
        action: data.action,
        fields: data.fields,
        method: data.method || 'POST'
    }

    // short delay so browser paints UI before submit
    setTimeout(() => {
        formEl.value?.submit()
    }, 500)
} catch (e) {
    console.error('Payment redirect failed:', e)
    errorMessage.value = t('We were unable to redirect you to the payment provider. Please try again.')
}
</script>
